// extracted by mini-css-extract-plugin
module.exports = {"logo":"Topbar_logo__Biy0U","logoBlock":"Topbar_logoBlock__2eoKU","menu":"Topbar_menu__1a_VF","support":"Topbar_support__2-NL7","dropdown":"Topbar_dropdown__3rQKQ"};